// extracted by mini-css-extract-plugin
export default {"root":"PortfolioDeclineForm_root__KL-xT","form":"PortfolioDeclineForm_form__673FK","body":"PortfolioDeclineForm_body__eSd4j","footer":"PortfolioDeclineForm_footer__fU8V7"};